module.exports = __webpack_public_path__ + "static/media/tn.1dad75c8.svg";